function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#1373E6",
  fillOpacity: 0.8,
  transform: "scale(0.902712 0.902712)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.375s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(40 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#1373E6",
  fillOpacity: 0.8,
  transform: "scale(0.599407 0.599407)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.25s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(60 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#1373E6",
  fillOpacity: 0.8,
  transform: "scale(0.247391 0.247391)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "-0.125s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(80 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "#1373E6",
  fillOpacity: 0.8,
  transform: "scale(0.0149742 0.0149742)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "scale",
  begin: "0s",
  calcMode: "spline",
  keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
  values: "0;1;0",
  keyTimes: "0;0.5;1",
  dur: "1s",
  repeatCount: "indefinite"
})));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-message",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "none"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.df31924d.svg";
export { ForwardRef as ReactComponent };